import { defineMessages, IntlShape } from 'react-intl';

const messages = defineMessages({
  dataTable: {
    id: 'Data table',
    defaultMessage: 'Data table',
  },
  labelDataSource: {
    id: 'Source',
    defaultMessage: 'Source',
  },
  descrDataSource: {
    id: 'descr_data_source',
    defaultMessage:
      'Must return a valid JSON array or object. If it is not a uni-koblenz.de domain, the delivering server must set the Access-Control-Allow-Origin HTTP header accordingly.',
  },
  labelIsSearchable: {
    id: 'Is searchable?',
    defaultMessage: 'Is searchable?',
  },
  labelColumns: {
    id: 'Columns',
    defaultMessage: 'Columns',
  },
  column: {
    id: 'Column',
    defaultMessage: 'Column',
  },
  labelLabel: {
    id: 'Label',
    defaultMessage: 'Label',
  },
  labelFieldInSource: {
    id: 'Field name in source',
    defaultMessage: 'Field name in source',
  },
  labelSortKey: {
    id: 'Field name to sort by',
    defaultMessage: 'Field name to sort by',
  },
  labelSortReverse: {
    id: 'Reverse sort',
    defaultMessage: 'Reverse sort',
  },
});

const ColumnSchema = (intl: IntlShape) => {
  return {
    title: intl.formatMessage(messages.column),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['label', 'field'],
      },
    ],
    properties: {
      label: {
        title: intl.formatMessage(messages.labelLabel),
      },
      field: {
        title: intl.formatMessage(messages.labelFieldInSource),
      },
    },
  };
};

export const DataTableSchema = (intl: IntlShape) => {
  const MyColumnsSchema = ColumnSchema(intl);
  return {
    title: intl.formatMessage(messages.dataTable),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'data_source',
          'searchable',
          'columns',
          'sort_key',
          'sort_reverse',
        ],
      },
    ],
    properties: {
      data_source: {
        title: intl.formatMessage(messages.labelDataSource),
        description: intl.formatMessage(messages.descrDataSource),
      },
      searchable: {
        title: intl.formatMessage(messages.labelIsSearchable),
        type: 'boolean',
        default: true,
      },
      columns: {
        title: intl.formatMessage(messages.labelColumns),
        schema: MyColumnsSchema,
        widget: 'object_list',
      },
      sort_key: {
        title: intl.formatMessage(messages.labelSortKey),
      },
      sort_reverse: {
        title: intl.formatMessage(messages.labelSortReverse),
        type: 'boolean',
      },
    },
    required: [],
  };
};

export default DataTableSchema;
